(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["vg-lightweight-whats-new"] && !Shopify.designMode) return;
  try {
    
  function initVgLightWhatsNew(root) {
    var scope = root || document;
    var carousels = scope.querySelectorAll('[data-vg-light-carousel]');

    carousels.forEach(function (carousel) {
      if (carousel.dataset.vgLightCarouselReady === 'true') return;

      var track = carousel.querySelector('[data-vg-light-carousel-track]');
      var previous = carousel.querySelector('[data-vg-light-carousel-previous]');
      var next = carousel.querySelector('[data-vg-light-carousel-next]');

      if (!track || !previous || !next) return;

      carousel.dataset.vgLightCarouselReady = 'true';

      function updateButtons() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        previous.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      }

      function scrollTrack(direction) {
        track.scrollBy({
          left: direction * track.clientWidth * 0.75,
          behavior: 'smooth'
        });
      }

      previous.addEventListener('click', function () {
        scrollTrack(-1);
      });

      next.addEventListener('click', function () {
        scrollTrack(1);
      });

      track.addEventListener('scroll', updateButtons, { passive: true });
      window.addEventListener('resize', updateButtons);
      updateButtons();
      window.setTimeout(updateButtons, 250);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initVgLightWhatsNew(document);
    });
  } else {
    initVgLightWhatsNew(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initVgLightWhatsNew(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
